import { render, staticRenderFns } from "./VipPlansList.vue?vue&type=template&id=7386cc96"
import script from "./VipPlansList.vue?vue&type=script&lang=js"
export * from "./VipPlansList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports